import React, { useState } from "react";

import FacilityDeletionRequestList from "./FacilityDeletionRequestList";
import AdminSearchWidget from "../db-list/AdminSearchWidget";
import ListWrapper from "../../../common/management/ListWrapper";
import ListContentWrapper from "../../../common/management/ListContentWrapper";

import {
  useDeleteFacility,
  useGetFacilityAdmin,
} from "../../../utils/useFacility";
import { genDisplayCount } from "../../../utils/GeneralUtils";
import { PageVisibility } from "../../../utils/PageVisibility";
import { RequestState } from "../../../utils/RequestState";

import { useAppSelector } from "../../../redux/hooks";
import { getAuthToken } from "../../../redux/reducers/auth";

type Props = {
  handleSearch?: (search: Array<string>) => void;
  currentPage: number;
  perView: number;
  search?: Array<string>;
};

const FacilityDeletionRequestListContainer: React.FC<Props> = ({
  handleSearch,
  currentPage,
  perView,
  search,
}) => {
  const authToken = useAppSelector(getAuthToken);

  const queryKey = {
    authToken,
    page: currentPage,
    per: perView,
    search: search?.join(" "),
    status: PageVisibility.DeletionRequest,
  };

  const {
    items: { facilities, totalEntries: entries, totalPage },
    isLoading,
  } = useGetFacilityAdmin(queryKey);

  const { mutateAsync: del, mutateLoading: deleteLoading } = useDeleteFacility([
    "facility",
    queryKey,
  ]);

  const [requestState, setRequestState] = useState<RequestState>(
    RequestState.Waiting
  );

  const handleDelete = async (id: string) => {
    if (authToken && id) {
      setRequestState(RequestState.Doing);
      const res = await del({ authToken, id });
      if (res !== null) {
        setRequestState(RequestState.Success);
      } else {
        setRequestState(RequestState.Failed);
      }
    }
  };

  return (
    <ListWrapper pageTitle="削除申請">
      <ListContentWrapper
        isLoading={isLoading || deleteLoading}
        displayCount={genDisplayCount(currentPage, totalPage, perView, entries)}
        totalEntries={entries}
        totalPage={totalPage}
        currentPage={currentPage}
        optionalComponent={
          handleSearch && search ? (
            <AdminSearchWidget handleSearch={handleSearch} search={search} />
          ) : undefined
        }
      >
        <FacilityDeletionRequestList
          facilities={facilities}
          requestState={requestState}
          handleDelete={handleDelete}
        />
      </ListContentWrapper>
    </ListWrapper>
  );
};

export default FacilityDeletionRequestListContainer;
